module.exports = __webpack_public_path__ + "static/media/font_wid.81600048.ico";